<central-login-header [platform]="currentPlatform"></central-login-header>

<div class="content">
    <form [formGroup]="contactForm" (ngSubmit)="process()">
        <h3 class="form-title">{{ 'central-login.admin.contact' | translate }}</h3>

        <div class="alert alert-info" *ngIf="isContactSuccessful">
            {{ 'central-login.admin.contact.success' | translate }}
        </div>

        <div class="alert alert-danger" *ngIf="!isContactSuccessful && messageSent">
            {{ 'central-login.admin.contact.error' | translate }}
        </div>

        <div *ngIf="!messageSent">
            <div class="form-group">
                <label class="form-control-label"
                    >{{ 'central-login.first.name.placeholder' | translate }}
                    <input type="text" id="firstName" formControlName="firstName" class="form-control" />
                </label>
                <div *ngIf="submitted && form.firstName.errors">
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.firstName.errors.required">{{ 'central-login.first.name.required' | translate }}</div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-control-label"
                    >{{ 'central-login.last.name.placeholder' | translate }}
                    <input type="text" id="lastName" formControlName="lastName" class="form-control" />
                </label>
                <div *ngIf="submitted && form.lastName.errors">
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.lastName.errors.required">{{ 'central-login.last.name.required' | translate }}</div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-control-label"
                    >{{ 'central-login.email' | translate }}
                    <input type="text" id="email" formControlName="email" class="form-control" />
                </label>
                <div *ngIf="submitted && form.email.errors">
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.email.errors.required">{{ 'central-login.email.required' | translate }}</div>
                    <div class="alert alert-danger mt-3 p-2" *ngIf="form.email.errors.email">{{ 'central-login.email.not.valid' | translate }}</div>
                </div>
            </div>

            <div class="form-group">
                <label class="form-control-label"
                    >{{ 'central-login.message' | translate }}
                    <textarea type="textarea" id="message" rows="15" formControlName="message" class="form-control"></textarea>
                </label>
                <div *ngIf="submitted && form.message.errors">
                    <div class="alert alert-danger mt-3 mb-0 p-2" *ngIf="form.message.errors.required">{{ 'central-login.message.required' | translate }}</div>
                </div>
            </div>

            <div class="row mt-3">
                <div class="col-md-12">
                    <button class="btn psd-variant w-100" [disabled]="submitting">{{ 'central-login.send' | translate }}</button>
                </div>
            </div>

            <re-captcha size="invisible" #invisibleRecaptcha (resolved)="setCaptchaToken($event)"> </re-captcha>
        </div>
    </form>
</div>

<central-login-footer></central-login-footer>
<central-login-background-slider [platform]="currentPlatform"></central-login-background-slider>
